<template>
<div>
    <v-card flat max-width="950px" class="mx-auto transparent" v-if="loaded">
        <HeadRoot 
            title="Reputation Planner"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="text-center mt-6 mb-n6" v-if="$route.params.id!='own'">
            <v-btn large text class="primary--text" @click="$router.push('/profile/'+$route.params.id)">
                <v-icon small left>fa-angle-left</v-icon>
                Back to Profile
            </v-btn>
        </div>
        
        <div v-if="item == null">
            <div class="text-center mt-12" v-if="third === false">
                <div class="primary--text title mt-12">
                    You haven't started your Online Reputation Planner.
                </div>
                <v-btn large depressed class="accent mb-12 mt-8" @click="$router.push('/planner/edit')">start now my reputation planner</v-btn>
            </div>
            <div class="text-center mt-12" v-if="third === true">
                <div class="primary--text title mt-12">
                    The user has not Online Reputation Planner yet.
                </div>
            </div>
        </div>

        <v-row v-if="item">
            <v-col cols="12" offset-md="1" md="10">
                <div class="text-center my-6" v-if="$route.params.id=='own'">
                    <v-btn large depressed class="accent" @click="$router.push('/planner/edit')">Edit planner</v-btn>
                </div>

                <div class="px-4 px-sm-8 pt-6 pb-10 cyan white--text mt-12" style="border-top-left-radius:5px; border-top-right-radius:5px">
                    <div class="d-flex justify-center flex-column align-center">
                        <UserAvatar class="mt-n12" :photo="photo" size="140" />
                        <div class="text-center">
                            <div class="display-1 mt-2">{{item.name}}</div>
                            <div class="mt-1" v-if="showProfile">PROFILE PLANNER</div>
                            <div class="mt-1" v-else>CONTACTS PLANNER</div>
                            <div class="font-weight-light caption mt-n1">MY ONLINE REPUTATION PLANNER</div>
                            <v-btn small depressed class="white cyan--text mt-5" @click="showProfile=!showProfile" v-if="showProfile">See my Contacts</v-btn>
                            <v-btn small depressed class="white cyan--text mt-5" @click="showProfile=!showProfile" v-else>See my profile</v-btn>
                        </div>
                    </div>
                </div>
                <PresentProfile :item="item" :top="top" v-if="showProfile" />
                <PresentContacts :item="item" :top="top" v-else />
            </v-col>
        </v-row>
        
    </v-card>
</div>
</template>

<script>
import Users from '@/firebase/users'
import PresentProfile from '@/components/planner/PresentProfile'
import PresentContacts from '@/components/planner/PresentContacts'

export default {
    data: () => ({
        loaded: false,
        showProfile: true,
        item: null,
        photo: null,
        third: false,
        top: null,
        tab: 0
    }),
    components: {
        PresentProfile,
        PresentContacts
    },
    mounted() {
        if (this.$route.params.id == 'own') {
            if (this.user.planner) {
                this.item = this.user.planner;
                this.photo = this.user.photo;
            }
            if (this.user.mytop) {
                this.top = this.user.mytop;
            }
            this.loaded = true;
        } else {
            this.getUser();
        }
    },
    methods: {
        getUser() {
            Users.get(this.$route.params.id)
                    .then(response => {
                        this.photo = response.doc.data().photo;
                        if (response.status === true) {
                            if (response.doc.data().planner) {
                                this.item = response.doc.data().planner;
                                if (response.doc.data().mytop) {
                                    this.top = response.doc.data().mytop;
                                }
                            } else {
                                this.third = true;
                            }
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>

